/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ControlDto } from './ControlDto';
import {
    ControlDtoFromJSON,
    ControlDtoFromJSONTyped,
    ControlDtoToJSON,
    ControlDtoToJSONTyped,
} from './ControlDto';
import type { GroupExtendedDto } from './GroupExtendedDto';
import {
    GroupExtendedDtoFromJSON,
    GroupExtendedDtoFromJSONTyped,
    GroupExtendedDtoToJSON,
    GroupExtendedDtoToJSONTyped,
} from './GroupExtendedDto';

/**
 * 
 * @export
 * @interface GroupWithSelectionDto
 */
export interface GroupWithSelectionDto {
    /**
     * 
     * @type {string}
     * @memberof GroupWithSelectionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithSelectionDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithSelectionDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithSelectionDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithSelectionDto
     */
    groupClass?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithSelectionDto
     */
    catalogId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithSelectionDto
     */
    catalogName?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithSelectionDto
     */
    parentGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithSelectionDto
     */
    parentGroupName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupWithSelectionDto
     */
    hasControls?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupWithSelectionDto
     */
    hasSubGroups?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GroupWithSelectionDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupWithSelectionDto
     */
    updated?: Date;
    /**
     * 
     * @type {Array<GroupExtendedDto>}
     * @memberof GroupWithSelectionDto
     */
    subGroups?: Array<GroupExtendedDto>;
    /**
     * 
     * @type {Array<ControlDto>}
     * @memberof GroupWithSelectionDto
     */
    controls?: Array<ControlDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GroupWithSelectionDto
     */
    selected?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupWithSelectionDto
     */
    isSelected?: boolean;
}

/**
 * Check if a given object implements the GroupWithSelectionDto interface.
 */
export function instanceOfGroupWithSelectionDto(value: object): value is GroupWithSelectionDto {
    return true;
}

export function GroupWithSelectionDtoFromJSON(json: any): GroupWithSelectionDto {
    return GroupWithSelectionDtoFromJSONTyped(json, false);
}

export function GroupWithSelectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupWithSelectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'groupClass': json['groupClass'] == null ? undefined : json['groupClass'],
        'catalogId': json['catalogId'] == null ? undefined : json['catalogId'],
        'catalogName': json['catalogName'] == null ? undefined : json['catalogName'],
        'parentGroupId': json['parentGroupId'] == null ? undefined : json['parentGroupId'],
        'parentGroupName': json['parentGroupName'] == null ? undefined : json['parentGroupName'],
        'hasControls': json['hasControls'] == null ? undefined : json['hasControls'],
        'hasSubGroups': json['hasSubGroups'] == null ? undefined : json['hasSubGroups'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'subGroups': json['subGroups'] == null ? undefined : ((json['subGroups'] as Array<any>).map(GroupExtendedDtoFromJSON)),
        'controls': json['controls'] == null ? undefined : ((json['controls'] as Array<any>).map(ControlDtoFromJSON)),
        'selected': json['selected'] == null ? undefined : json['selected'],
        'isSelected': json['isSelected'] == null ? undefined : json['isSelected'],
    };
}

export function GroupWithSelectionDtoToJSON(json: any): GroupWithSelectionDto {
    return GroupWithSelectionDtoToJSONTyped(json, false);
}

export function GroupWithSelectionDtoToJSONTyped(value?: GroupWithSelectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'groupId': value['groupId'],
        'title': value['title'],
        'description': value['description'],
        'groupClass': value['groupClass'],
        'catalogId': value['catalogId'],
        'catalogName': value['catalogName'],
        'parentGroupId': value['parentGroupId'],
        'parentGroupName': value['parentGroupName'],
        'hasControls': value['hasControls'],
        'hasSubGroups': value['hasSubGroups'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'subGroups': value['subGroups'] == null ? undefined : ((value['subGroups'] as Array<any>).map(GroupExtendedDtoToJSON)),
        'controls': value['controls'] == null ? undefined : ((value['controls'] as Array<any>).map(ControlDtoToJSON)),
        'selected': value['selected'],
        'isSelected': value['isSelected'],
    };
}

